export const contactMethodsTypes = {
    phone: 0,
    mobile: 1,
    whatsapp: 2,
    email: 3,
    socialMedia: 4
}

export const contactMethodsSelectOptions = [
    {
        label: 'تلفن ثابت',
        value: contactMethodsTypes.phone
    },
    {
        label: 'تلفن همراه',
        value: contactMethodsTypes.mobile
    },
    {
        label: 'واتسپ',
        value: contactMethodsTypes.whatsapp
    },
    {
        label: 'ایمیل',
        value: contactMethodsTypes.email
    },
    {
        label: 'سایر شبکه های اجتماعی',
        value: contactMethodsTypes.socialMedia
    },
]
const contactNumber = (type, value) => {
    if (parseInt(type) === contactMethodsTypes.phone || parseInt(type) === contactMethodsTypes.mobile || parseInt(type) === contactMethodsTypes.whatsapp) {
        let stringValue = String(value);
        stringValue = stringValue.replace(/^0+/, '');
        return stringValue;
    }
    return value;
};

export const contactMethodsLinks = (type, value) => {
    switch (type) {
        case contactMethodsTypes.phone:
            return `tel:${value}`;

        case contactMethodsTypes.mobile:
            return `tel:${value}`;

        case contactMethodsTypes.whatsapp:
            return `https://api.whatsapp.com/send/?phone=98${contactNumber(type ,value)}&text&app_absent=0`;
        case contactMethodsTypes.email:
            return `mailto:${value}`;


        case contactMethodsTypes.socialMedia:
            return value;

        default:
            return;
    }
}

export const contactMethodsValueFieldLabel = (type) => {
    switch (type) {
        case contactMethodsTypes.phone:
            return "شماره تلفن";

        case contactMethodsTypes.mobile:
            return "شماره موبایل";

        case contactMethodsTypes.whatsapp:
            return "شماره واتسپ";

        case contactMethodsTypes.email:
            return "آدرس ایمیل";

        case contactMethodsTypes.socialMedia:
            return "لینک";

        default:
            return "مقدار";
    }
}